import EditorContext from './context'
import Editor from './editor'
import EditorProvider from './editor-provider'
import Controls from './controls'
import StickyEditor from './builds/sticky-editor'
import { EditorState } from 'draft-js'
import { sanitizeHtml } from 'pobble-components/dist/presentation'
import { convertToHTML, convertFromHTML } from 'draft-convert'

const createStateFromHtml = text => {
  const contentState = convertFromHTML(sanitizeHtml(text))
  return EditorState.createWithContent(contentState)
}

const stateToHTML = editorState =>
  sanitizeHtml(convertToHTML(editorState.getCurrentContent()))

export {
  EditorContext,
  Editor,
  EditorProvider,
  Controls,
  StickyEditor,
  EditorState,
  stateToHTML,
  sanitizeHtml,
  createStateFromHtml
}
